document.addEventListener("DOMContentLoaded", () => {

  // ---------------------------
  // 共通フォーム要素
  // ---------------------------
  const formInput = document.querySelector('.js-form-input');
  const formConfirm = document.querySelector('.js-form-confirm');
  const confirmBtn = document.querySelector('.js-confirm-btn');
  const backBtn = document.querySelector('.js-back-btn');
  const confirmGuide = document.getElementById('js-confirm-guide');


  // ---------------------------
  // トップページ判定
  // ---------------------------
  const isHome = document.body.classList.contains("home");
  const isSP = window.matchMedia("(max-width: 768px)").matches;

  // ---------------------------
  // ページ内リンクスクロール（トップ・下層ページ共通）
  // ---------------------------

  // リンククリック時の処理
  const links = document.querySelectorAll('a[href*="#"]');
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      const url = new URL(link.href);
      const hash = url.hash;
      if (!hash) return;
      const target = document.querySelector(hash);
      if (!target) return;

      // 他ページリンクの場合は通常遷移
      if (url.pathname !== window.location.pathname) return;

      e.preventDefault();
      const header = document.querySelector(".l-header");
      const headerHeight = header ? header.offsetHeight : 0;
      const pos =
        target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({ top: pos, behavior: "smooth" });
    });
  });

  // ページロード時にURLにハッシュがある場合のスクロール
  window.addEventListener("DOMContentLoaded", () => {
    const hash = window.location.hash;
    if (!hash) return;

    const target = document.querySelector(hash);
    if (!target) return;

    const header = document.querySelector(".l-header");
    const headerHeight = header ? header.offsetHeight : 0;

    // 下層ページだけ余白を追加
    const extraMargin = !document.body.classList.contains("home") ? 50 : 0;

    const pos =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      headerHeight -
      extraMargin;

    // 少し待ってからスクロール（画像やヘッダーのロードを待つため）
    setTimeout(() => {
      window.scrollTo({ top: pos, behavior: "smooth" });
    }, 50);
  });

  // ---------------------------
  // SPヘッダー ナビ
  // ---------------------------
  const openBtn = document.querySelector(".openbtn");
  const navHamburger = document.getElementById("l-header__nav-hamburger");
  const circleBg = document.querySelector(".circle-bg");

  if (openBtn && navHamburger && circleBg) {
    openBtn.addEventListener("click", () => {
      openBtn.classList.toggle("active");
      navHamburger.classList.toggle("panelactive");
      circleBg.classList.toggle("circleactive");
    });

    navHamburger.querySelectorAll("a:not(.drawer-toggle)").forEach((link) => {
      link.addEventListener("click", () => {
        openBtn.classList.remove("active");
        navHamburger.classList.remove("panelactive");
        circleBg.classList.remove("circleactive");
      });
    });
  }

  // ---------------------------
  // ドロワーメニュー
  // ---------------------------
  document.querySelectorAll(".drawer-toggle").forEach((toggle) => {
    toggle.addEventListener("click", (e) => {
      const drawer = toggle.closest(".drawer");
      const menu = drawer.querySelector(".drawer-menu");
      if (!menu) return;
      e.preventDefault();

      document.querySelectorAll(".drawer.is-open").forEach((openItem) => {
        if (openItem !== drawer) {
          openItem.classList.remove("is-open");
          openItem.querySelector(".drawer-menu").style.maxHeight = null;
        }
      });

      drawer.classList.toggle("is-open");
      menu.style.maxHeight = drawer.classList.contains("is-open")
        ? menu.scrollHeight + "px"
        : null;
    });
  });

  // ---------------------------
  // トップページ動画
  // ---------------------------
  if (isHome) {
    const mainButton = document.querySelector(".movie__main-trigger");
    const mainCaption = document.querySelector(
      ".wakuwaku_movie-gallery-main .movie__caption"
    );
    const thumbButtons = document.querySelectorAll(".movie__thumbs button");

    if (mainButton) {
      if (!mainButton.dataset.thumbHtml)
        mainButton.dataset.thumbHtml = mainButton.innerHTML;

      const playMainVideo = (videoId, caption) => {
        if (mainButton.querySelector("iframe")) return;
        const iframe = document.createElement("iframe");
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1`;
        iframe.setAttribute("allowfullscreen", "");
        iframe.setAttribute(
          "allow",
          "autoplay; encrypted-media; picture-in-picture"
        );
        iframe.style.width = "100%";
        iframe.style.height = "100%";
        mainButton.innerHTML = "";
        mainButton.appendChild(iframe);
        mainCaption.textContent = caption;
      };

      if (!isSP) {
        // PCクリック時
        mainButton.addEventListener("click", () => {
          playMainVideo(mainButton.dataset.videoId, mainCaption.textContent);
        });

        thumbButtons.forEach((button) => {
          button.addEventListener("click", () => {
            mainButton.innerHTML = button.innerHTML;
            mainButton.dataset.videoId = button.dataset.videoId;
            mainCaption.textContent = button.dataset.caption;
            thumbButtons.forEach((btn) => btn.classList.remove("is-active"));
            button.classList.add("is-active");
          });
        });
      } else {
        // SP時はサムネクリックで直接再生
        thumbButtons.forEach((button) => {
          button.addEventListener("click", () => {
            const videoId = button.dataset.videoId;
            if (button.querySelector("iframe")) return;
            if (!button.dataset.thumbHtml)
              button.dataset.thumbHtml = button.innerHTML;
            const iframe = document.createElement("iframe");
            iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&enablejsapi=1`;
            iframe.setAttribute("allowfullscreen", "");
            iframe.setAttribute(
              "allow",
              "autoplay; encrypted-media; picture-in-picture"
            );
            iframe.style.width = "100%";
            iframe.style.aspectRatio = "16 / 9";
            button.innerHTML = "";
            button.appendChild(iframe);
          });
        });
      }
    }
  }

  // ---------------------------
  // 下層ページ動画（サムネ→1本再生）
  // ---------------------------
  if (!isHome) {
    const blocks = Array.from(document.querySelectorAll(".js-yt-embed"));

    if (blocks.length) {
      // 初期サムネ（button）HTMLを退避（復元用）
      blocks.forEach((block) => {
        const btn = block.querySelector(".js-yt-play");
        if (btn && !block.dataset.thumbHtml) {
          block.dataset.thumbHtml = btn.outerHTML;
        }
      });

      // サムネクリック（イベント委譲：復元後も効く）
      document.addEventListener("click", (e) => {
        const btn = e.target.closest(".js-yt-play");
        if (!btn) return;

        const block = btn.closest(".js-yt-embed");
        if (!block) return;

        // 仕様：他を停止（ただしモーダル内のみを止めたいなら、blockの属するmodalで絞り込み可能）
        stopAllExcept(block);

        // すでに iframe があるなら何もしない
        if (block.querySelector("iframe")) return;

        const url = block.getAttribute("data-yt-url") || "";
        const parsed = buildYouTubeEmbed(url);
        if (!parsed) return;

        const { videoId, start, end } = parsed;

        const params = new URLSearchParams({
          autoplay: "1",
          controls: "1",
          loop: "1",
          playlist: videoId,
          enablejsapi: "1",
          origin: window.location.origin,
        });

        if (start !== null) params.set("start", String(start));
        if (end !== null) params.set("end", String(end));

        const iframe = document.createElement("iframe");
        iframe.setAttribute("title", "YouTube video player");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute(
          "allow",
          "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        );
        iframe.setAttribute("allowfullscreen", "");
        iframe.src = `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
        iframe.style.width = "100%";
        iframe.style.height = "100%";

        // サムネを消して iframe を入れる
        btn.remove();
        block.appendChild(iframe);
      });

      // モーダルが閉じたら：停止 → iframe削除 → サムネ復元
      document.addEventListener("interviewModal:close", (e) => {
        const modal = e.detail?.modal;
        if (!modal) return;

        const targetBlocks = Array.from(modal.querySelectorAll(".js-yt-embed"));

        targetBlocks.forEach((block) => {
          const iframe = block.querySelector("iframe");
          if (iframe) {
            stopYouTubeIframe(iframe);

            // stop送信直後にremoveすると効かないことがあるので少し待つ
            window.setTimeout(() => {
              iframe.remove();
            }, 50);
          }

          // サムネ（button）を復元（無い場合のみ）
          if (!block.querySelector(".js-yt-play") && block.dataset.thumbHtml) {
            block.insertAdjacentHTML("afterbegin", block.dataset.thumbHtml);
          }
        });
      });

      function stopAllExcept(current) {
        blocks.forEach((block) => {
          if (block === current) return;
          const iframe = block.querySelector("iframe");
          if (!iframe) return;
          stopYouTubeIframe(iframe);
        });
      }

      function stopYouTubeIframe(iframe) {
        iframe.contentWindow?.postMessage(
          JSON.stringify({ event: "command", func: "stopVideo", args: [] }),
          "*"
        );
      }

      function buildYouTubeEmbed(inputUrl) {
        let u;
        try {
          u = new URL(inputUrl);
        } catch {
          return null;
        }

        let videoId = null;

        if (u.hostname.includes("youtu.be")) {
          videoId = u.pathname.replace("/", "");
        }
        if (!videoId && u.searchParams.get("v")) {
          videoId = u.searchParams.get("v");
        }
        if (!videoId && u.pathname.includes("/embed/")) {
          videoId = u.pathname.split("/embed/")[1]?.split("/")[0] || null;
        }
        if (!videoId) return null;

        const startRaw = u.searchParams.get("start") || u.searchParams.get("t");
        const start = startRaw ? parseYouTubeTime(startRaw) : null;

        const endRaw = u.searchParams.get("end");
        const end = endRaw ? parseInt(endRaw, 10) : null;

        return { videoId, start, end: Number.isFinite(end) ? end : null };
      }

      function parseYouTubeTime(value) {
        if (/^\d+$/.test(value)) return parseInt(value, 10);

        let total = 0;
        const h = value.match(/(\d+)h/);
        const m = value.match(/(\d+)m/);
        const s = value.match(/(\d+)s/);

        if (h) total += parseInt(h[1], 10) * 3600;
        if (m) total += parseInt(m[1], 10) * 60;
        if (s) total += parseInt(s[1], 10);

        if (total === 0 && /^\d+s$/.test(value)) return parseInt(value, 10);
        return total || 0;
      }
    }
  }

  // ---------------------------
  // TOP画像ギャラリー、モーダル、その他の処理は元のまま
  // ---------------------------
  // TOP 画像ギャラリー
  $(function () {
    //female
    let femaleStarted = false;
    $('.js-gallery-main-female').on('afterChange', function () {
      if (femaleStarted) return;
      femaleStarted = true;
      $('.wakuwaku_gallery-female .gallery__main-initial').hide();
      $('.js-gallery-main-female').show();
    });
    $('.js-gallery-main-female').slick({
      slidesToShow: 1,
      arrows: true,
      prevArrow: $('.wakuwaku_gallery-female .gallery__arrow.is-prev'),
      nextArrow: $('.wakuwaku_gallery-female .gallery__arrow.is-next'),
      asNavFor: '.js-gallery-thumbs-female',
      swipe: true,
      infinite: false
    });
    $('.js-gallery-thumbs-female').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.js-gallery-main-female',
      focusOnSelect: true,
      swipeToSlide: true,   // ★これが一番大事
      speed: 300,
      cssEase: 'ease-out',
      arrows: false,
      infinite: false
    });

    // male
    let maleStarted = false;
    $('.js-gallery-main-male').on('afterChange', function () {
      if (maleStarted) return;
      maleStarted = true;
      $('.wakuwaku_gallery-male .gallery__main-initial').hide();
      $('.js-gallery-main-male').show();
    });
    $('.js-gallery-main-male').slick({
      slidesToShow: 1,
      arrows: true,
      prevArrow: $('.wakuwaku_gallery-male .gallery__arrow.is-prev'),
      nextArrow: $('.wakuwaku_gallery-male .gallery__arrow.is-next'),
      asNavFor: '.js-gallery-thumbs-male',
      swipe: true,
      infinite: false
    });
    $('.js-gallery-thumbs-male').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.js-gallery-main-male',
      focusOnSelect: true,
      swipeToSlide: true,
      speed: 300,
      cssEase: 'ease-out',
      arrows: false,
      infinite: false
    });
  });


  // TOP 応募する 地方モーダル
  document.querySelectorAll('.map__area').forEach(area => {
    const modal = area.querySelector('.pref-modal');

    area.addEventListener('click', e => {
      // リンククリックは除外
      if (e.target.closest('.pref-modal a')) return;

      document.querySelectorAll('.pref-modal').forEach(m => {
        if (m !== modal) m.classList.remove('is-open');
      });

      modal.classList.toggle('is-open');
    });
  });

  // インタビューモーダル
  (function () {
    const DURATION = 400;

    function closeAllModals() {
      document.querySelectorAll(".js-interview-modal").forEach((modal) => {
        // ★閉じる前に通知（動画リセット用）
        document.dispatchEvent(
          new CustomEvent("interviewModal:close", { detail: { modal } })
        );

        modal.style.opacity = "0";
        modal.style.display = "none";
      });

      document.body.style.overflow = "";
    }

    function openModal(trigger, e) {
      e.preventDefault();

      const targetId = trigger.getAttribute("data-target");
      const modal = document.getElementById(targetId);
      if (!modal) return;

      // ① すでに開いているモーダルがあれば全て閉じる
      closeAllModals();

      // ② 対象モーダルを開く
      modal.style.display = "block";
      modal.style.opacity = "0";
      modal.style.transition = `opacity ${DURATION}ms`;

      requestAnimationFrame(() => {
        modal.style.opacity = "1";
      });

      // 背景スクロール停止
      document.body.style.overflow = "hidden";
    }

    function closeModal(modal) {
      modal.style.transition = `opacity ${DURATION}ms`;
      modal.style.opacity = "0";

      // ★閉じる前に通知（動画リセット用）
      document.dispatchEvent(
        new CustomEvent("interviewModal:close", { detail: { modal } })
      );

      window.setTimeout(() => {
        modal.style.display = "none";
      }, DURATION);

      document.body.style.overflow = "";
    }

    function init() {
      // open
      document.querySelectorAll(".js-interview-modal-open").forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          openModal(trigger, e);
        });
      });

      // close（閉じるボタンのみ）
      document.querySelectorAll(".js-interview-modal-close").forEach((btn) => {
        btn.addEventListener("click", (e) => {
          e.preventDefault();

          const modal = btn.closest(".js-interview-modal");
          if (!modal) return;

          closeModal(modal);
        });
      });
    }

    // DOM ready（WordPress対応）
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();

// ---------------------------
// フォーム確認
// ---------------------------

if (formInput && formConfirm && confirmBtn && backBtn) {
  const requiredInputs = formInput.querySelectorAll('[aria-required="true"]');
  const pageTitle = document.querySelector(".p-contact__title");
  const confirmError = document.getElementById("confirm-error");
  const contactInfoBox = document.querySelector(".contact-info-box");
  const contactLead = document.querySelector(".p-contact__lead");

  // メールアドレス形式チェック
  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function checkRequired() {
    let allFilled = true;

    requiredInputs.forEach((input) => {
      const value = input.value.trim();

      // 未入力チェック
      if (!value) {
        allFilled = false;
        return;
      }

      // メールアドレス形式チェック
      if (input.type === "email" || input.name === "your-email") {
        if (!isValidEmail(value)) {
          allFilled = false;
        }
      }
    });

    // ボタン制御
    confirmBtn.disabled = !allFilled;
    confirmBtn.setAttribute("aria-disabled", !allFilled);

    // 入力途中ではエラーを出さない
    if (confirmError) {
      confirmError.textContent = "";
    }

    // ガイド文言
    confirmGuide.textContent = allFilled
      ? "必須項目の入力が完了しました。"
      : "全ての必須項目を正しく入力すると、内容を確認できるようになります。";

    confirmGuide.classList.toggle("is-active", allFilled);
  }

  // 入力時チェック
  requiredInputs.forEach((input) => {
    input.addEventListener("input", checkRequired);
  });

  // ---------------------------
  // 確認画面へ
  // ---------------------------
  confirmBtn.addEventListener("click", () => {
    const targetElements = formConfirm.querySelectorAll("[data-confirm]");

    targetElements.forEach((el) => {
      const fieldName = el.dataset.confirm;
      const inputs = formInput.querySelectorAll(
        `[name="${fieldName}"], [name="${fieldName}[]"]`
      );
      if (!inputs.length) return;

      if (inputs[0].type === "radio" || inputs[0].type === "checkbox") {
        const checked = [...inputs]
          .filter((i) => i.checked)
          .map((i) => i.value);
        el.textContent = checked.length ? checked.join("、") : "（未選択）";
      } else {
        el.textContent = inputs[0].value || "（未入力）";
      }
    });

    // エラー表示をクリア
    if (confirmError) {
      confirmError.textContent = "";
    }

    // 入力 → 確認 切り替え
    formInput.style.display = "none";
    formConfirm.style.display = "block";

    // contact-info-box を非表示
    if (contactInfoBox) {
      contactInfoBox.style.display = "none";
    }

    // リード文を確認用に差し替え
    if (contactLead) {
      contactLead.textContent = "入力内容をご確認のうえ、送信してください。";
    }

    document.getElementById("confirm-flag").value = "1";

    // タイトル変更
    document.title = "お問い合わせ 確認画面 | KDDI採用ポータル：au shop";
    if (pageTitle) {
      pageTitle.textContent = "お問い合わせ 確認画面";
    }

    // フォーカス制御
    formConfirm.setAttribute("tabindex", "-1");
    formConfirm.focus();
    window.scrollTo(0, 0);
  });

  // ---------------------------
  // 入力画面へ戻る
  // ---------------------------
  backBtn.addEventListener("click", () => {
    formInput.style.display = "block";
    formConfirm.style.display = "none";

    // contact-info-box を再表示
    if (contactInfoBox) {
      contactInfoBox.style.display = "";
    }

    // リード文を入力用に戻す
    if (contactLead) {
      contactLead.textContent =
        "下記フォームに必要事項をご入力のうえ、送信してください。";
    }

    document.getElementById("confirm-flag").value = "0";

    // タイトルを戻す
    document.title = "お問い合わせ 入力画面 | KDDI採用ポータル：au shop";
    if (pageTitle) {
      pageTitle.textContent = "お問い合わせ 入力画面";
    }

    // 最初の必須項目にフォーカス
    const firstInput = formInput.querySelector('[aria-required="true"]');
    if (firstInput) {
      firstInput.focus();
    }

    window.scrollTo(0, 0);
  });

  // ---------------------------
  // 送信完了後
  // ---------------------------
  document.addEventListener("wpcf7mailsent", () => {
    location.href = "/thanks/";
  });
}

});
